import router from "@/router";
import { store } from "@/store";

export const UtilsPlugin = {
  install(Vue, options) {
    const i18n = options.i18n; // předáš při instalaci

    Vue.prototype.$utils = {

      localDate: function(jsonDate) {
        if (jsonDate == null) return null;

        // Získáme aktuální jazyk z i18n
        const userLocale = i18n.locale || "cs";

        return new Date(jsonDate).toLocaleDateString( userLocale );
      },

      localDateTime: function(jsonDate) {
        if (jsonDate == null) return null;

        // Získáme aktuální jazyk z i18n
        const userLocale = i18n.locale || "cs";

        const date = new Date(jsonDate);
        const options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false,
        };
        return date.toLocaleString( userLocale, options );
      },

      localCurr: function(jsonNumber) {
        if (jsonNumber == null) return null;

        // Získáme aktuální jazyk z i18n
        const userLocale = i18n.locale || "cs";

        // Češi uvidí symbol "Kč", ostatní kód "CZK"
        const currencyDisplay = userLocale.startsWith("cs") ? "symbol" : "code";

        return jsonNumber.toLocaleString(userLocale, {
          style: "currency",
          currency: "CZK",
          currencyDisplay: currencyDisplay
        });
      },

      capitalizeFirstLetter(word) {
        if (!word || typeof word !== "string") {
          return "";
        }

        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      },

      // Pokud view definuje title, pak nastaví title stránky jako:
      // portal.title + " - " + title, např. : Služby na Webu - Košík
      setPageTitle(vm) {
        const title = this.getTitle(vm);
        if (title) {
          document.title = title;
        }
      },

      // Vrátí title view
      getTitle(vm) {
        const { title } = vm.$options;
        var res = Vue.prototype.$nazevObce + " - " + vm.$t("portal.title");
        if (title && title != null) {
          var suffix = title;
          if (typeof title === "function") suffix = title.call(vm);

          if (suffix === "") return res;

          return res + " - " + suffix;
        }
      },

      // Vrátí aktuální rok na klientu
      getCurrentYear() {
        return new Date().getFullYear();
      },

      hasResponseData(response) {
        return response != null && response.status == 200 && response.data != null;
      },

      isAuthenticationGranted(response) {
        return this.hasResponseData(response) && response.data.authenticationGranted;
      },

      isResponseBooleanTrue(response) {
        return this.hasResponseData(response) && response.data == true;
      },
      saveLastPageBeforeLogin() {
        // Save current page URL before redirecting to login
        const currentRoute = router.currentRoute;
        if (currentRoute.name !== "Login" && currentRoute.name !== "TestLogin") {
          console.log("Save last page: " + currentRoute.fullPath);
          store.dispatch("setLastVisitedPage", currentRoute.fullPath);
        }
      },

      zpracujVysledekOdeslaniFormularu(response ) {
          if (response.data.podani) {
            console.log("Zpracuji vysledek ulozedi do SSL postaru");
            // -- Ulozim podani --
            // Předpokládáme, že PDF data jsou ve vlastnosti 'pdfData' jako Base64 řetězec
            const base64Podani = response.data.podani;
            // Dekódování Base64 řetězce
            const binaryStringPodani = atob(base64Podani);
            const lenPodani = binaryStringPodani.length;
            const bytesPodani = new Uint8Array(lenPodani);
            for (let i = 0; i < lenPodani; i++)
              bytesPodani[i] = binaryStringPodani.charCodeAt(i);

            // Vytvoření blobu
            const blobPodani = new Blob([bytesPodani], { type: "application/pdf" });
            store.dispatch("setBlobPodani", blobPodani);

            // -- Ulozim osvedceni, pokud dorazilo --
            const base64Osvedceni = response.data.osvedceni;
            if (base64Osvedceni != null && base64Osvedceni.length > 0) {
              // Dekódování Base64 řetězce
              const binaryStringOsvedceni = atob(base64Osvedceni);
              const lenOsvedceni = binaryStringOsvedceni.length;
              const bytesOsvedceni = new Uint8Array(lenOsvedceni);
              for (let i = 0; i < lenOsvedceni; i++)
                bytesOsvedceni[i] = binaryStringOsvedceni.charCodeAt(i);

              // Vytvoření blobu
              const blobOsvedceni = new Blob([bytesOsvedceni], { type: "application/pdf" });
              store.dispatch("setBlobOsvedceni", blobOsvedceni);
            } else
              store.dispatch("setBlobOsvedceni", null);

            if (router.currentRoute.name != "osvedceniZadosti")
              router.push({ path: "/" + this.$customerUuid + "/formular/osvedceni" });
          }
        }
    };
  },
};
